import { render } from "./AdParameterCardItem.vue?vue&type=template&id=f181367e&scoped=true"
import script from "./AdParameterCardItem.vue?vue&type=script&lang=js"
export * from "./AdParameterCardItem.vue?vue&type=script&lang=js"

import "./AdParameterCardItem.vue?vue&type=style&index=0&id=f181367e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f181367e"]])

export default __exports__